import React, { useEffect, useState} from "react";
import Popup from "../ui/Popup";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { pubCall } from "../utils/PubSub";
import Menu from "../ui/Menu";
import Nav from "../ui/Nav";
import { showError, showMessage } from "../ui/Message";
import { ROUTES } from "../utils/Routes";
import VirtualTable from "../ui/VirtualTable";
import { createModal } from "../hooks/createModal";
import CustomerCount from "../popups/CustomerCount";
import Confirm from "../popups/Confirm";
import { useTabs } from "../hooks/useTabs";
import Input from "../ui/Input";
import { cust_createType, cust_editType, cust_deleteType } from "../controllers/CustomersController";

export default function CustomerType(props) {

    const NEW_ROW = { type: "", __new: true };


    const { controller = "", callback = () => { }, signal = {}, value = "", route = "" } = props;
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState("");
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        edit: false,
        new: false,
    })

     // data with new row added. 
    const tableData = state.new
        ? [...data, NEW_ROW]
        : data;   

    const isNewRow = (row) => row?.__new === true || row?.type === "";

    const getTypes = () => {
        pubCall("customer_type.get", {}, (_s, _r) => {
            if (_s) {
                let _f = _r.rows.find(item => item.type === value);
                if (_f) { setSelected(_f) } else { setSelected(_r.rows[0])}
                setData(_r.rows);

            } else {
                showError(_r);
            }
        })
    }

    

    useEffect(() => {
        getTypes();
    }, [])

    const deleteType = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} title={"Delete this customer type?"} signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) { 
                    cust_deleteType({ customer_type: selected }, (_s, _r) => {
                        if (!_s) return showError(_r);
                        const newData = data.filter(item => item.type !== selected.type);
                        setData(newData);
                        if (newData.length > 0) { 
                            setSelected(newData[0]); 
                        } else { 
                            setSelected({}) 
                        }
                    })
                }
            }
        })
    }
    
    const canEditRow = (row) => {
        if (window.bm_state.value !== ROUTES.HELPERS.CUSTOMER_TYPES) return false;
        
        if (isNewRow(row) && state?.new) return true;

        if (state?.edit && row?.type === selected?.type) return true;
        
        return false;
    }

    const defaultTabs = [
        { label: "type", key: "type", value: "" },
        { label: "desc", key: "desc", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "type");

    useEffect(() => {
        if (!state.new && !state.edit) return;
        requestAnimationFrame(() => {
            const el = refs?.current[index];
            if (el) el.focus();
        });
    }, [index]);

    const updateSelectedType = () => {
        window.bm_state.value = ROUTES.HELPERS.CONFIRM;
        createModal({
            alert: true,
            component: <Confirm controller={controller} events={[KBD.D, KBD.U]} description={"Update the primary list of Customer Types with those found in Customer file?"} signal={signal} route={ROUTES.HELPERS.CONFIRM} />, closable: true, callback: (e) => {
                window.bm_state.value = route;
                if (e) {
                    pubCall("customer_type.update", {customer_type: selected }, (_s, _r) => {
                        if (_s) {
                            showMessage("Customer types updated");
                            getTypes();
                        } else {
                            showError(_r);
                        }
                    });
                }
            }
        })
    }

    const openCountType = () => {
        window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES_COUNT;
        pubCall("customer.searchShop", {type: selected?.type, limit: 100, offset: 0}, (_s, _r) => {
            if (_s) {
                const totalCount = _r.total;
                createModal({
                    closable: true,
                    title: `${totalCount} customers with type: ${selected?.type || ""}`,
                    component: <CustomerCount
                        controller={controller}
                        type={selected?.type}
                        initialData={_r.rows}
                        route={ROUTES.HELPERS.CUSTOMER_TYPES_COUNT}
                        />,
                        callback: () => {
                            window.bm_state.value = ROUTES.HELPERS.CUSTOMER_TYPES;
                        }
                    });
            } else {
                showError(_r);
            }
        });
    }

    const showNewRow = () => {
        setState(s => ({ ...s, edit: false, new: true }));
        setSelected(NEW_ROW);
        setIndex("type");
        requestAnimationFrame(() => {
            refs.current?.type?.focus?.();
        });
    };

    const showEditRow = () => {
        if (selected?.type) {
            setTabs([
                { label: "type", key: "type", value: selected.type || "" },
                { label: "desc", key: "desc", value: selected.desc || "" },
            ]);
            setState(s => ({ ...s, edit: true, new: false }));
            setIndex("type");
            requestAnimationFrame(() => {
                refs.current?.type?.focus?.();
            });
        }
    }

    const saveType = () => {
        if (state.edit) {
            cust_editType({ type: getVal("type"), desc: getVal("desc"), customer_type: selected }, (_s, _r) => {
                if (!_s) return showError(_r);
                showMessage("Customer type updated");
                setState(s => ({ ...s, edit: false, new: false }));
                getTypes();
            });
        } else if (state.new) {
            cust_createType({ type: getVal("type"), desc: getVal("desc") }, (_s, _r) => {
                if (!_s) return showError(_r);
                showMessage("Customer type created");
                setState(s => ({ ...s, edit: false, new: false }));
                setTabs(defaultTabs);
                getTypes();
            }); 
        }
    };

    const cancelEditRow = () => {
        setState(s => ({ ...s, edit: false, new: false }));
        setTabs(defaultTabs);
    };

    const cust_edit_nav = [
        { key: KBD.ESCAPE, action: () => cancelEditRow() },
        { key: KBD.ENTER, action: () => index === "desc" ? saveType() : next() },
        { key: KBD.PAGE_DOWN, action: () => saveType() },
        { key: KBD.ARROW_DOWN, action: () => { next() } },
        { key: KBD.ARROW_UP, action: () => { prev() } },
    ]

    const nav = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(selected?.type) } },
        { key: KBD.C, text: "Count", action: () => {openCountType()} },
        { key: KBD.D, text: "Del", action: () => {deleteType()} },
        { key: KBD.E, text: "Edt", action: showEditRow },
        { key: KBD.N, text: "New", action: showNewRow },
        { key: KBD.U, text: "Upd", action: () => {updateSelectedType()} },
    ]

    useEffect(() => {
        const actions = (state.new || state.edit) ? cust_edit_nav : nav;
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ENTER, KBD.PAGE_DOWN]);
        return cleanup;
    }, [index, tabs, refs, state.new, state.edit, selected, data])

    const nextType = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const nextIndex = data.findIndex(item => item?.id === selected?.id) + _rows;
        if (data.length <= nextIndex) { setSelected(data[0]);}
        if (nextIndex < data.length) { setSelected(data[nextIndex]);}
    };

    const prevType = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.id === selected?.id) - _rows;
        if (prevIndex < 0) { setSelected(data[data.length - 1]); return;}
        if (prevIndex >= 0) { setSelected(data[prevIndex]);}
    };

    const columns = [
        { key: "type", align: "center", title: <>Type</>, width: 50, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("type")} edit={true} /></>
            } else {
                return e;
            }
        }},
        { key: "desc", align: "left", title: <>Description</>, width: 220, render: (e, f) => {
            if (canEditRow(f)) {
                return <><Input className="fill" {...editProps("desc")} edit={true} /></>
            } else {
                return e;
            }
        }},
    ]

    return (
        <>
            <Popup
                title={"Customer Type"}
                width={"auto"}
                callback={callback}
                component={
                    <>
                    <VirtualTable
                        controller={controller}
                        row_key={"id"}
                        next={nextType}
                        prev={prevType}
                        route={route}
                        current={selected}
                        data={tableData}
                        width={270}
                        height={320}
                        offset={0}
                        columns={columns}
                        onRowClick={(item, event, index) => { setSelected(item) }}
                        onRowDoubleClick={(item) => { if (!state.edit && !state.new) callback(item?.type) }}
                    />
                    {(!state.new && !state.edit) && <div style={{ "margin": "4px 0" }}><Nav nav={nav}/></div>}
                    </>
                }
            />
        </>
    )
}